import * as Yup from 'yup';

export const Status = Object.freeze({
  idle: 0,
  open: 1,
  closed: 2,
  redemption: 3,
  ended: 4,
});

export const defaultValues = Object.freeze({
  image: {},
  description: '',
  date: null,
  numPrizes: 1,
  ticketPolicy: 'once',
  tags: [],
});

export const validate = Yup.object().shape({
  image: Yup.object(),
  description: Yup.string().required('Required'),
  date: Yup.date().nullable(true),
  numPrizes: Yup.number().required('Required'),
  ticketPolicy: Yup.string().required('Required'),
  tags: Yup.array().of(Yup.object({})),
});
